
export default {
  name: 'EducationSettings',
  data() {
    return {
      i18n: 'pages.education.settings',
      blocksData: {},
      isShowFaculty: false,
      isFacultyLoading: false
    }
  },

  computed: {
    isBlocksInSettings() {
      return Object.keys(this.blocksData).length
    }
  },

  async mounted() {
    const { additional, main, isHideElectives } =
      (await this.$store.dispatch('education/getSettingsBlocksList')) || {}

    this.blocksData = { main, additional }
    this.isShowFaculty = !isHideElectives
  },

  methods: {
    async changeFacultyHideStatus(value) {
      this.isFacultyLoading = true
      const response = await this.$store.dispatch(
        'education/setFacultyHiddenStatus',
        !value
      )

      if (!response?.status || response?.status !== 'ok') {
        this.isShowFaculty = value
      }

      this.isFacultyLoading = false
    }
  }
}
